import { Injectable } from '@angular/core';
import { fetchAndSaveFile, saveUrlAsFile } from '@core/utils/helpers/file-download.helper';

/**
 * Saves a media file to the user's disk. Stateless and `root`-provided — it operates only on the
 * URL/blob handed to it, so it is safe to share across every viewer instance. The anchor/blob save
 * mechanics live in the shared `file-download.helper`.
 */
@Injectable({ providedIn: 'root' })
export class MediaDownloadService {
  /**
   * Trigger a browser download. Streams the bytes through a blob (so cross-origin sources download
   * rather than navigate); on a network failure it falls back to a plain anchor download.
   */
  async download(url: string, fileName: string): Promise<void> {
    try {
      await fetchAndSaveFile(url, fileName);
    } catch {
      saveUrlAsFile(url, fileName);
    }
  }
}
